import React, { useState } from 'react';
import '../styles/ButtonOptions.css';

function ButtonOptions({ options, type, onSelect, minSelections = 1 }) {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const isMultiChoice = type === 'multi_choice';

  const handleOptionClick = (option) => {
    if (isMultiChoice) {
      // Toggle selection for multi-choice
      setSelectedOptions(prev => {
        if (prev.includes(option)) {
          return prev.filter(o => o !== option);
        } else {
          return [...prev, option];
        }
      });
    } else {
      // Single choice - submit immediately
      onSelect([option]);
    }
  };

  const handleSubmit = () => {
    if (selectedOptions.length >= minSelections) {
      onSelect(selectedOptions);
    }
  };

  const isOptionSelected = (option) => selectedOptions.includes(option);
  const canSubmit = selectedOptions.length >= minSelections;

  return (
    <div className="button-options">
      <div className="options-grid">
        {options.map((option, idx) => (
          <button
            key={idx}
            className={`option-button ${isOptionSelected(option) ? 'selected' : ''}`}
            onClick={() => handleOptionClick(option)}
          >
            {option}
            {isMultiChoice && isOptionSelected(option) && (
              <span className="checkmark">✓</span>
            )}
          </button>
        ))}
      </div>

      {isMultiChoice && (
        <div className="submit-container">
          <button
            className="submit-button"
            onClick={handleSubmit}
            disabled={!canSubmit}
          >
            Continue ({selectedOptions.length} selected)
          </button>
        </div>
      )}
    </div>
  );
}

export default ButtonOptions;
